module.exports = __webpack_public_path__ + "assets/img/4.85674e27.jpg";